import React , {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {  setCurrentStep, saveToHistory, pushToHistory, clearHistory } from './personalPricePlanBlockSlice';
import { PersonalPricePlanStep } from './constant';

const BtnNextStep = ({
  canProceed, // boolean OR function
  text,
  disabled = false,
  className = '',
  errorText,
  setCurrentStep,
  nextStep,
  personalPricePlan,
  saveToHistory,
  pushToHistory,
  buttonColor = 'primaryColor',
  clearHistoryInd = false
}) => {

  const [canContinue, setCanContinue] = useState(true);
  const [triedContinue, setTriedContinue] = useState(false);

  useEffect(() => {
    if (typeof canProceed === "boolean"  && triedContinue) {
      setCanContinue(canProceed);
    }
  }, [canProceed]);

  async function handleNextStep() {
    setTriedContinue(true);
    let result = true;
    if (typeof canProceed === "function") {
      result = await canProceed();
    } else if (typeof canProceed === "boolean") {
      result = canProceed;
    }

    setCanContinue(result);

    if (!result) return;

    const currentStep = personalPricePlan.currentStep;

    if (clearHistoryInd) {
      clearHistory();
    } else {
      saveToHistory(currentStep);
    }

    if (nextStep) {
      setCurrentStep(nextStep);
    }
  }

  return (
    <div className={`continue-button ${className}`}>
      {!canContinue && triedContinue && (
        <div className="error center">{errorText}</div>
      )}

      <BtnSubmit
        onclick={handleNextStep}
        text={text || "המשך"}
        disabled={disabled}
        className={buttonColor}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  personalPricePlan: state.personalPricePlan,
});

const mapDispatchToProps = {
  setCurrentStep,
  saveToHistory,
  pushToHistory,
  clearHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(BtnNextStep);
